import './Onas.less';

import Page from '../../hoc/Page.js';
import Header from '../../components/Header/Header';
import WhyUs from '../../components/WhyUs/WhyUs';


const onas = () =>{

};

export default Page(onas);